<template>
  <AdultPinCheck>
    <div slot="title">
      <strong class="ch-adult-title">자녀보호 설정</strong>
      <p class="ch-adult-text01">자녀보호를 위한 설정으로<br>성인만 설정가능합니다.</p>
    </div>
    <template v-slot:bottom_buttons="scopedValue">
      <BottomButtons :scopedValue="scopedValue"></BottomButtons>
    </template>
  </AdultPinCheck>
</template>
<script>
import AdultPinCheck from '@/views/adult/AdultPinCheck.vue'
import BottomButtons from '@/views/adult/ChildrenProtectionBottomButtons.vue'
export default {
  name: 'AdultPinCheckForChildrenProtection',
  components: {
    AdultPinCheck,
    BottomButtons
  }
}
</script>
